import Vue from 'vue'
import App from './App.vue'
import router from './router'
import i18n from './i18n'
import store from './store'
import './global'
import axios from 'axios'

import '@/assets/fonts/iconfont.css'

import langEn from 'element-ui/lib/locale/lang/en'
import langZH from 'element-ui/lib/locale/lang/zh-CN'
import locale from 'element-ui/lib/locale'

// 自定义指令
import directives from '@/utils/directives.js'
Vue.use(directives)

// Vue.config.errorHandler = function (err, vm, info) {
//   axios.post('http://logger.zallds.com/api', {
//     app: 'zb.zma-smart.com',
//     logger: err.stack,
//     msg: info,
//   })
//     .then(res => {
//       console.log(res);
//     })
//     .catch(error => {
//       console.log(error);
//     });
// }

// 全局守卫判断是否有token
router.beforeEach((from, to, next) => {
  const languageCode = window.localStorage.getItem('languageCode') || 'zh_cn'
  if (languageCode == 'zh_cn') {
    // 设置语言
    locale.use(langZH)
  } else {
    locale.use(langEn)
  }
  axios.get('/static/language/' + languageCode + '.json').then(res => {
    i18n.mergeLocaleMessage(languageCode, res)
    next()
  })
})
new Vue({
  el: '#app',
  i18n,
  router,
  store,
  render: h => h(App)
})
